import React from "react";
import useStyles from "./styles";
import { __t } from "@core/translation/translation";
import TabsPanel from "@components/TabsPanel";
import DealComponent from "./DealComponent";

const MarketOrderTemplate3 = () => {
  const classes = useStyles();

  const tabs = [
    {
      label: __t("BUY"),
      component: <DealComponent type="buy" />,
    },
    {
      label: __t("SELL"),
      component: <DealComponent type="sell" />,
    },
  ];
  return <TabsPanel tabs={tabs} className={classes.appBar} size="small" />;
};

export default MarketOrderTemplate3;
